(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ugc-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ugc-stories]');
    roots.forEach(function (root) {
      var id = root.getAttribute('data-ugc-id');
      var viewer = document.querySelector('[data-ugc-viewer][data-ugc-for="' + id + '"]');
      var dataScript = document.querySelector('[data-ugc-data="' + id + '"]');
      if (!viewer || !dataScript) return;

      var stories = [];
      try {
        stories = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }

      var hoverAutoplay = root.getAttribute('data-hover-autoplay') === 'true';
      var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 5000;
      var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      var mediaEl = viewer.querySelector('[data-ugc-media]');
      var captionEl = viewer.querySelector('[data-ugc-caption]');
      var ctaEl = viewer.querySelector('[data-ugc-cta]');
      var progressEl = viewer.querySelector('[data-ugc-progress]');
      var muteBtn = viewer.querySelector('[data-ugc-mute]');
      var current = 0;
      var timer = null;
      var isMuted = true;

      function buildProgressBars() {
        progressEl.innerHTML = '';
        stories.forEach(function () {
          var span = document.createElement('span');
          span.innerHTML = '<i></i>';
          progressEl.appendChild(span);
        });
      }

      function setProgressState(index, percent) {
        var bars = progressEl.children;
        for (var i = 0; i < bars.length; i++) {
          bars[i].classList.remove('is-complete');
          var i_el = bars[i].querySelector('i');
          if (i < index) {
            i_el.style.width = '100%';
          } else if (i === index) {
            i_el.style.width = percent + '%';
          } else {
            i_el.style.width = '0%';
          }
        }
      }

      function clearTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function goTo(index) {
        clearTimer();
        mediaEl.querySelectorAll('video').forEach(function (v) { v.pause(); });
        if (index < 0) index = 0;
        if (index >= stories.length) {
          close();
          return;
        }
        current = index;
        var story = stories[current];
        mediaEl.innerHTML = '';

        if (story.type === 'video' && story.videoSrc) {
          var video = document.createElement('video');
          video.src = story.videoSrc;
          video.poster = story.poster || '';
          video.muted = isMuted;
          video.playsInline = true;
          video.autoplay = true;
          mediaEl.appendChild(video);
          video.play().catch(function () {});

          video.addEventListener('timeupdate', function () {
            if (!video.duration) return;
            setProgressState(current, (video.currentTime / video.duration) * 100);
          });
          video.addEventListener('ended', function () { goTo(current + 1); });
        } else {
          var img = document.createElement('img');
          img.src = story.image;
          img.alt = story.caption || '';
          mediaEl.appendChild(img);

          var startTime = Date.now();
          timer = setInterval(function () {
            var pct = Math.min(100, ((Date.now() - startTime) / autoplayMs) * 100);
            setProgressState(current, pct);
            if (pct >= 100) {
              goTo(current + 1);
            }
          }, 50);
        }

        captionEl.textContent = story.caption || '';
        if (story.link) {
          ctaEl.href = story.link;
          ctaEl.textContent = story.linkText || 'Ver más';
          ctaEl.classList.add('is-visible');
        } else {
          ctaEl.classList.remove('is-visible');
        }
      }

      function open(index) {
        buildProgressBars();
        viewer.classList.add('is-open');
        viewer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        goTo(index);
      }

      function close() {
        clearTimer();
        mediaEl.querySelectorAll('video').forEach(function (v) { v.pause(); });
        viewer.classList.remove('is-open');
        viewer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      root.querySelectorAll('[data-ugc-story]').forEach(function (btn) {
        var video = btn.querySelector('[data-ugc-hover-video]');

        if (hoverAutoplay && supportsHover && video) {
          btn.addEventListener('mouseenter', function () {
            btn.classList.add('is-hover-playing');
            video.currentTime = 0;
            video.play().catch(function () {});
          });
          btn.addEventListener('mouseleave', function () {
            btn.classList.remove('is-hover-playing');
            video.pause();
          });
        }

        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-index'), 10) || 0;
          open(idx);
        });
      });

      viewer.querySelectorAll('[data-ugc-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      var prevBtn = viewer.querySelector('[data-ugc-prev]');
      var nextBtn = viewer.querySelector('[data-ugc-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          isMuted = !isMuted;
          muteBtn.textContent = isMuted ? '🔇' : '🔊';
          var v = mediaEl.querySelector('video');
          if (v) v.muted = isMuted;
        });
      }

      document.addEventListener('keydown', function (e) {
        if (!viewer.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') goTo(current + 1);
        if (e.key === 'ArrowLeft') goTo(current - 1);
      });

      var touchStartX = null;
      viewer.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      viewer.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var diff = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(diff) > 40) {
          diff < 0 ? goTo(current + 1) : goTo(current - 1);
        }
        touchStartX = null;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
